
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'InfoIcon',
    props: {
        size: {
            type: Number,
            default: 16,
        },
        color: {
            type: String,
            default: '#2A3B51',
        },
        className: {
            type: String,
            default: '',
        },
    },
})
